import React from 'react';
import PropTypes from 'prop-types';
import Observer from 'react-intersection-observer';
import { VideoContainer } from '../styles/ambient-video.style';

const propTypes = {
  videoId: PropTypes.string,
};

const defaultProps = {
  videoId: '',
};

/**
 * News Component
 */
class AmbientVideo extends React.Component {
  /**
   * Plays/pauses the video if it is in view
   * @param {boolean} inView whether or not the video is in view
   */
  handlerObserver(inView) {
    if (inView) {
      this.videoRef.play();
    } else {
      this.videoRef.pause();
    }
  }

  /**
   * Renders an AmbientVideo Component
   * @returns {XML} AmbientVideo Component
   */
  render() {
    const { videoId } = this.props;
    const videoUrl = `/videos/${videoId}.mp4`;

    return (
      <VideoContainer>
        <Observer tag="div" threshold={0.5} onChange={inView => this.handlerObserver(inView)}>
          <video
            muted
            ref={(el) => {
              this.videoRef = el;
            }}
            loop
          >
            <source src={videoUrl} type="video/mp4" />
          </video>
        </Observer>
      </VideoContainer>
    );
  }
}

AmbientVideo.propTypes = propTypes;
AmbientVideo.defaultProps = defaultProps;

export default AmbientVideo;



// WEBPACK FOOTER //
// ./src/components/ambient-video/components/ambient-video.js